/* eslint-disable max-classes-per-file -- one tiny error hierarchy; splitting it three ways hides the relationship */

/** Base class so callers can catch every range problem with one `instanceof`. */
export class CodeRangeError extends Error {}

/** Per spec: any individual range that expands to more than RANGE_EXPANSION_LIMIT is rejected. */
export class RangeTooLargeError extends CodeRangeError {
  constructor(public readonly token: string, public readonly size: number) {
    super(`Range too large — please narrow it ("${token}" → ${size} codes)`);
    this.name = "RangeTooLargeError";
  }
}

/**
 * CLE-2750 — a token that contains a dash but does not parse as a range. It used to pass through
 * as the literal string and save as one unmatched "code": a rule that looks fine in the editor and
 * silently never fires. Now it is an error the user sees.
 */
export class InvalidCodeRangeError extends CodeRangeError {
  constructor(public readonly token: string) {
    super(
      `"${token}" is not a valid code range — use two same-width endpoints, e.g. 80000-89999 or J1642-J1700`
    );
    this.name = "InvalidCodeRangeError";
  }
}
